module.exports = __webpack_public_path__ + "fonts/notosans-medium-web.992ddf4.ttf";